import React, { Component } from 'react'
import { Link } from 'gatsby'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'
import {
  faArrowUp,
  faMapMarkerAlt,
  faEnvelope,
  faMapMarked,
  faMobileAlt,
  faMobile,
  faCommentDots,
  faAngleDown,
  faPhone,
  faMapPin,
  faMap,
  faMapMarkedAlt,
  faMapSigns,
  faStar,
  faCalendar,
  faCalendarCheck,
} from '@fortawesome/free-solid-svg-icons'

import {
  faCcAmex,
  faCcDiscover,
  faCcMastercard,
  faCcVisa,
  faCcJcb,
  faFacebookMessenger,
} from '@fortawesome/free-brands-svg-icons'
import SubscribeForm from './subscribeForm'
import NavLink from './nav-link'
import SocialIcons from './socialIcons'

const IconLink = styled.div`
  a {
    text-decoration: none;
    font-size: 0.75em;
    line-height: 1.3em;
    letter-spacing: 0.18em;
    text-transform: Uppercase;
    .w3-row {
      font-size: 1.8em;
    }

    text-decoration: none;
    :hover {
      color: #a0a0a0;
    }
  }
`
const InfoLink = styled.div`
  text-transform: none;
  text-decoration: none;
  color: #c6c6c6;
  font-size: 0.75em;
  letter-spacing: 0.17em;
`

const ContactsWrapper = styled.div`
  @media (max-width: 600px) {
    border-right: none !important;
  }
`
const ContactsLink = (props) => {
  const {
    contactType,
    icon,
    excerpt,
    infoLink,
    info,
    borderLeft,
    borderRight,
    borderTop,
    borderBottom,
    relValues,
  } = props
  return (
    <ContactsWrapper
      className="w3-padding-16"
      style={{
        borderLeft: `${borderLeft}`,
        borderRight: `${borderRight}`,
        borderTop: `${borderTop}`,
        borderBottom: `${borderBottom}`,
      }}
    >
      <IconLink>
        <NavLink rel={relValues} to={contactType}>
          <div className="w3-row w3-padding">
            <FontAwesomeIcon
            style={{fontDisplay: "optional"}}
            icon={icon} />
          </div>
          {excerpt}
        </NavLink>
      </IconLink>
      <div>
        <InfoLink>{info}</InfoLink>
      </div>
    </ContactsWrapper>
  )
}

const HeaderWrapper = styled.div`
  text-transform: Uppercase;
  letter-spacing: 0.125em;
  font-size: 1.2em;
  line-height: 1.25em;
`
const FooterWrapper = styled.div`
  width: 60%;
  font-size: 0.75em;
  line-height: 1.3333333333em;
  letter-spacing: 0.05em;
  margin-top: 0.3333333333em;
  margin: auto;
`

// const MainWrapper = styled.div`
//   justify-content: space-around;
//   font-size: 1.4em;
//   line-height: 1em;
//   width: 100%;
// `

// const NavLink = props => {
//   const { borderBottom } = props
//   return (
//     <div>
//       <h1>g</h1>
//     </div>
//   )
// }

const FooterNavLik = styled.button`
  text-decoration: none;
  font-size: 0.75em;
  letter-spacing: 0.18em;
  text-transform: Uppercase;
`

const FooterTerms = styled.div`
  font-size: 0.75em;
  letter-spacing: 0.18em;
  text-transform: Uppercase;
  color: #c6c6c6;
  a {
    text-decoration: none;
    :hover {
      color: #a0a0a0;
    }
  }
`

const ConnectSection = (props) => {
  const { borderRight, connectHeader, connectFooter, connectMain } = props
  return (
    <div className="w3-padding-64" style={{ borderRight: `${borderRight}` }}>
      <div className="w3-row w3-padding-16">
        <HeaderWrapper>{connectHeader}</HeaderWrapper>
      </div>
      <div className="w3-row w3-padding-32">{connectMain}</div>
      <div className="w3-row w3-padding-16">
        <FooterWrapper>{connectFooter}</FooterWrapper>
      </div>
    </div>
  )
}

const footer = () => (
  <div className="w3-row w3-center">
    <div className="w3-row w3-black ">
      <div
        className="w3-row  "
        style={{ margin: 'var(--center)', maxWidth: 'var(--width)' }}
      >
        <div className="w3-container">
          <div className="w3-third">
            <ContactsLink
              contactType="tel:201 245 0649"
              icon={faPhone}
              excerpt="(201) 245-0649 M-F 9AM-6PM, EDT"
              info="M-F 9am-6pm, EDT"
              infoLink=""
              borderLeft="none"
              borderRight="1px solid #3b3b3b"
              borderTop="none"
              borderBottom="none"
            />
          </div>
          <div className="w3-third">
            <ContactsLink
              contactType="tel:201 245 0649"
              icon={faCommentDots}
              excerpt="Text With Us"
              info="M-F 9am-6pm, EDT"
              infoLink=""
              borderLeft="none"
              borderRight="1px solid #3b3b3b"
              borderTop="none"
              borderBottom="none"
            />
          </div>
          <div className="w3-third">
            <ContactsLink
              contactType="mailto:info@longmakeup.com"
              icon={faEnvelope}
              excerpt="Contact Us"
              info="Responses in 12-24 Hours"
              infoLink=""
              borderLeft="none"
              borderRight="none"
              borderTop="none"
              borderBottom="none"
            />
          </div>
        </div>
      </div>
    </div>
    <div className="w3-row">
      <div
        className="w3-row  "
        style={{ margin: 'var(--center)', maxWidth: 'var(--width)' }}
      >
        <div className="w3-container">
          <div className="w3-half">
            <ConnectSection
              connectHeader="Let's Connect on Social"
              connectMain={
                <div style={{ fontSize: '1.4em', margin: '0.7em auto' }}>
                  <SocialIcons />
                </div>
              }
              connectFooter="Follow us on your favorite platforms.
            Check out new permanent trends,
            videos, and share your favorite looks."
              // borderRight="1px solid #e4e4e4"
              borderRight="none"
            />
          </div>
          <div className="w3-half">
            <ConnectSection
              connectHeader="Sign up for emails"
              connectMain={
                <div className="w3-bar w3-border">
                  <SubscribeForm />
                </div>
              }
              connectFooter="Subscribe to the LM mailing list to receive updates on new trends,
            special offers and other discounts."
              borderRight="none"
            />
          </div>
        </div>
      </div>
      <div className="w3-row w3-black ">
        <div
          className="w3-row  "
          style={{ margin: 'var(--center)', maxWidth: 'var(--width)' }}
        >
          <div className="w3-container">
            <div className="w3-half">
              <ContactsLink
                contactType="https://g.page/longmakeup?share"
                icon={faMapMarkedAlt}
                excerpt="Visit"
                info="View on Map"
                infoLink=""
                borderLeft="none"
                borderRight="1px solid #3b3b3b"
                borderTop="none"
                borderBottom="none"
                relValues="noopener noreferrer nofollow"
              />
            </div>
            <div className="w3-half">
              <ContactsLink
                contactType="/blog"
                icon={faStar}
                excerpt="Blog"
                info="See All Posts"
                infoLink=""
                borderLeft="none"
                borderRight="none"
                borderTop="none"
                borderBottom="none"
                relValues="follow"
              />
            </div>
          </div>
        </div>
      </div>
      <div
        className="w3-row w3-black "
        style={{
          borderTop: '1px solid #3b3b3b',
          borderBottom: '1px solid #3b3b3b',
        }}
      >
        <div
          className="w3-row  "
          style={{
            margin: 'var(--center)',
            maxWidth: 'var(--width)',
          }}
        >
          <div className="w3-container">
            <ContactsLink
              contactType="https://squareup.com/appointments/book/3Q13NMMB2RG0E/longmakeup-inc-new-york-ny"
              icon={faCalendarCheck}
              excerpt="Book an Appointment"
              info="Online Booking"
              infoLink=""
              borderLeft="none"
              borderRight="none"
              borderTop="none"
              borderBottom="none"
              relValues="noopener noreferrer nofollow"
            />
          </div>
        </div>
      </div>
      <div className="w3-row w3-black">
        <div
          className="w3-row  "
          style={{ margin: 'var(--center)', maxWidth: 'var(--width)' }}
        >
          <div className="w3-container footer-navigation">
          <div className="w3-quarter">
              <div className="w3-col">
                <div className="w3-block w3-dropdown-hover w3-mobile w3-border w3-border-black w3-padding-32">
                  <NavLink to="/about/">
                    <FooterNavLik
                      type="button"
                      className="w3-button"
                      style={{ color: 'white' }}
                    >
                      About
                      <FontAwesomeIcon
                                style={{fontDisplay: "optional"}}
                      icon={faAngleDown} />
                    </FooterNavLik>
                  </NavLink>

                  <div className="w3-dropdown-content w3-bar-block w3-card-4">
                    <NavLink
                      to="/permanent-makeup-services-nyc/"
                      className=" w3-button w3-mobile"
                    >
                      Permanent Makeup Services NYC
                    </NavLink>
                    <NavLink
                      to="/permanent-makeup-artist/"
                      className=" w3-button w3-mobile"
                    >
                      Permanent Makeup Artist
                    </NavLink>
                    <NavLink
                      to="/permanent-makeup-and-digital-microblading-in-nyc/"
                      className=" w3-button w3-mobile"
                    >
                      Permanent Makeup NYC
                    </NavLink>
                    <NavLink
                      to="/permanent-makeup-nj/"
                      className=" w3-button w3-mobile"
                    >
                      Permanent Makeup NJ
                    </NavLink>
                  </div>
                </div>
              </div>
            </div>
            <div className="w3-quarter">
              <div className="w3-col">
                <div className="w3-block w3-dropdown-hover w3-mobile w3-border w3-border-black w3-padding-32">
                  <NavLink to="/permanent-makeup-removal/">
                    <FooterNavLik
                      type="button"
                      className="w3-button"
                      style={{ color: 'white' }}
                    >
                      Removal
                      <FontAwesomeIcon
                                style={{fontDisplay: "optional"}}
                      icon={faAngleDown} />
                    </FooterNavLik>
                  </NavLink>

                  <div className="w3-dropdown-content w3-bar-block w3-card-4">
                  <NavLink
                      to="/microblading/"
                      className=" w3-button w3-mobile"
                    >
                      Microblading
                    </NavLink>
                  </div>
                </div>
              </div>
            </div>

            {/* <div className="w3-quarter">
              <div className="w3-col">
                <div className="w3-block w3-dropdown-hover w3-mobile w3-border w3-border-black w3-padding-32">
                  <NavLink to="/permanent-makeup-removal/">
                    <FooterNavLik
                      type="button"
                      className="w3-button"
                      style={{ color: 'white' }}
                    >
                      Removal {''}
                      <FontAwesomeIcon
                                style={{fontDisplay: "optional"}}
                      icon={faAngleDown} />
                    </FooterNavLik>
                  </NavLink>
                  <div className="w3-dropdown-content w3-bar-block w3-card-4">
                    <NavLink
                      to="/permanent-eyebrows-removal/"
                      className="w3-button w3-mobile"
                    >
                      Permanent Eyebrows Removal
                    </NavLink>
                    <NavLink
                      to="/microblading-removal/"
                      className="w3-button w3-mobile"
                    >
                      Microblading Removal
                    </NavLink>
                  </div>
                </div>
              </div>
            </div> */}
            <div className="w3-quarter">
              <div className="w3-col">
                <div className="w3-block w3-dropdown-hover w3-mobile w3-border w3-border-black w3-padding-32">
                  <NavLink to="/before-during-and-after-permanent-makeup/">
                    <FooterNavLik
                      type="button"
                      className="w3-button"
                      style={{ color: 'white' }}
                    >
                      Before and Aftercare
                      <FontAwesomeIcon
                                style={{fontDisplay: "optional"}}
                      icon={faAngleDown} />
                    </FooterNavLik>
                  </NavLink>

                  <div className="w3-dropdown-content w3-bar-block w3-card-4">
                    <NavLink
                      to="/before-permanent-eyebrows/"
                      className=" w3-button w3-mobile"
                    >
                      Before Permanent Eyebrows
                    </NavLink>
                    <NavLink
                      to="/before-permanent-eyeliner/"
                      className=" w3-button w3-mobile"
                    >
                      Before Permanent Eyeliner
                    </NavLink>
                    <NavLink
                      to="/before-permanent-lips/"
                      className=" w3-button w3-mobile"
                    >
                      Before Permanent Lips
                    </NavLink>
                    <NavLink
                      to="/permanent-makeup-eyebrows-aftercare/"
                      className=" w3-button w3-mobile"
                    >
                      Permanent Makeup Eyebrows Aftercare
                    </NavLink>
                    <NavLink
                      to="/permanent-makeup-eyeliner-aftercare/"
                      className=" w3-button w3-mobile"
                    >
                      Permanent Makeup Eyeliner Aftercare
                    </NavLink>
                    <NavLink
                      to="/permanent-makeup-lips-aftercare/"
                      className=" w3-button w3-mobile"
                    >
                      Permanent Makeup Lips Aftercare
                    </NavLink>
                  </div>
                </div>
              </div>
            </div>
            <div className="w3-quarter">
              <div className="w3-col">
                <div className="w3-block w3-button w3-mobile w3-border w3-border-black w3-padding-32">
                  <NavLink to="/pricing/">
                    <FooterNavLik
                      type="button"
                      className="w3-button"
                      style={{ color: 'white' }}
                    >
                      Pricing
                    </FooterNavLik>
                  </NavLink>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="w3-row w3-black "
          style={{
            borderTop: '1px solid #3b3b3b',
            // borderBottom: '1px solid #3b3b3b',
          }}
        >
          <div
            className="w3-row  "
            style={{ margin: 'var(--center)', maxWidth: 'var(--width)' }}
          >
            <div className="w3-container">
              <div className="w3-half">
                <div className="w3-padding-32">
                  <FooterTerms>
                    <NavLink to="/terms-and-conditions/" rel="nofollow">
                      Terms & Conditions
                    </NavLink>
                  </FooterTerms>
                </div>
              </div>
              <div className="w3-half">
                <div className="w3-padding-32">
                  <FooterTerms>
                    <NavLink to="/sitemap-0.xml" rel="follow">
                      Sitemap
                    </NavLink>
                  </FooterTerms>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="w3-row w3-black ">
          <div className="w3-row  " style={{ margin: 'var(--center)' }}>
            <div className="w3-container">
              <div className="w3-third">
                <div className="w3-padding-16" />
              </div>
              <div className="w3-third">
                <div
                  className="w3-padding-16"
                  style={{ fontSize: '0.8em', letterSpacing: '0.18em' }}
                >
                  <a
                    href="https://goo.gl/maps/7iN2qYomFVRyFK276"
                    style={{ textDecoration: 'none' }}
                  >
                    30 East 60th Street, #1103, New York, NY 10022
                  </a>
                </div>
                <div style={{ fontSize: '0.8em', letterSpacing: '0.18em' }}>
                  <a
                    href="mailto:info@longmakeup.com"
                    style={{ textDecoration: 'none' }}
                  >
                    info@longmakeup.com
                  </a>
                </div>
                <div
                  className="w3-padding-16"
                  style={{ color: '#c6c6c6', fontSize: '0.8em' }}
                >
                  Copyright © {new Date().getFullYear()} LongMakeup Inc. All
                  rights reserved.
                </div>
              </div>
              <div className="w3-third">
                {/* <div className="w3-padding-16" style={{ float: 'left' }}>
                  <a
                    href="#home"
                    className="w3-dark-grey w3-hover-light-grey w3-button
         to-the-top-button"
                  >
                    <FontAwesomeIcon
                              style={{fontDisplay: "optional"}}
                    icon={faArrowUp} /> Top
                  </a>
                </div> */}
              </div>
              <div
                className="w3-padding-32"
                style={{ textDecoration: 'none', color: '#c6c6c6' }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default footer
// blog replace to Link gatsby
